import { EditorHeaderActions } from './components/editor-header-actions'
import { SystemDescriptionBar } from './components/system-description-bar'
import { PreviewRailPanel } from './components/preview/preview-rail-panel'
import { usePreviewRailStore } from './components/preview/preview-rail-store'
import { cn } from '@/lib/utils'
import { FirstMessageSection } from './components/sections/first-message-section'
import { KnowledgeSection } from './components/sections/knowledge-section'
import { MediaSection } from './components/sections/media-section'
import { MetaSection } from './components/sections/meta-section'
import { NarrativeSection } from './components/sections/narrative-section'
import { PromptTemplateSection } from './components/sections/prompt-template-section'
import { TagsSection } from './components/sections/tags-section'

type Props = {
  engineId?: string
}

export function Editor(_props: Props) {
  const railOpen = usePreviewRailStore((s) => s.open)

  return (
    <div className='bg-muted/30 min-h-screen'>
      {/* Sticky 顶部栏 */}
      <header className='bg-background/70 sticky top-0 z-30 border-b backdrop-blur'>
        {/* 让 header 宽度和两列布局对齐（左 5xl + 右 520px） */}
        <div
          className={cn(
            'mx-auto flex min-h-[3.5rem] items-center px-4 py-2 sm:h-14 sm:px-6 sm:py-0',
            railOpen ? 'max-w-full' : 'max-w-5xl lg:max-w-[calc(5xl+520px)]'
          )}
        >
          <EditorHeaderActions />
        </div>
      </header>

      {/* 主体：两列布局（左主内容 + 右 rail） */}
      <div
        className={cn(
          'mx-auto grid gap-6 px-4 py-6 sm:px-6 sm:py-8',
          'grid-cols-1 lg:grid-cols-[minmax(0,1fr)_auto]',
          railOpen ? 'max-w-full' : 'max-w-5xl lg:max-w-[calc(5xl+520px)]'
        )}
      >
        {/* 左列：主内容（仍保持 max-w-5xl 的视觉密度） */}
        <main className='min-w-0'>
          <div className={railOpen ? 'max-w-none' : 'mx-auto max-w-5xl'}>
            <div className='space-y-6 sm:space-y-7'>
              {/* 系统说明条 */}
              <SystemDescriptionBar />
              <MetaSection />
              <TagsSection />
              <MediaSection />
              <NarrativeSection />
              <PromptTemplateSection />
              <KnowledgeSection />
              <FirstMessageSection />
            </div>
          </div>
        </main>

        {/* 右列：Rail（展开/收起通过 width 动画） */}
        <aside
          className={cn(
            'transition-[width] duration-200 ease-out',
            'hidden lg:block',
            railOpen ? 'w-[520px]' : 'w-0'
          )}
        >
          <div
            className={cn(
              // header 高度 h-14 = 3.5rem
              'sticky top-14 h-[calc(100vh-3.5rem)]',
              'overflow-hidden',
              'transition-opacity duration-150',
              railOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
            )}
          >
            <PreviewRailPanel />
          </div>
        </aside>
      </div>
    </div>
  )
}
